import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useAuth } from '../utils/AuthContext';
import Layout from './Layout';
import UploadHydroService from './UploadHydroData';
import ProcessHydroData from './ProcessHydroData';
import { Environment } from "../utils/Environment";
import { useLocation } from "react-router-dom";
import { postWithUsername } from "../services/fetchWrapper";

const apiUrl = Environment.getApiUrl();// or use your Environment util

const steps = [
    () => <UploadHydroService />,
    () => <ProcessHydroData />
];

const HydroFlow: React.FC = () => {
    const username = localStorage.getItem("userName") || "";
    const [step, setStep] = useState(0);
    const { isLoggedIn, userName, logout } = useAuth();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const location = useLocation();
    useEffect(() => {
        const fetchLatestJobId = async () => {
            try {
                const client_id = localStorage.getItem("client_id");
                if (!client_id) {
                    setError("No client ID found. Please log in again.");
                    setLoading(false);
                    return;
                }
                // needs to retrieve from user db not hydro
                let response = await fetch(`${apiUrl}/get-latest-job-id?client_id=${encodeURIComponent(client_id)}`);
                let data = await response.json();
                if (data.job_id) {
                    localStorage.setItem("job_id", data.job_id);
                } else {
                    // Fallback: get job_id from user table (first-time user)
                    response = await postWithUsername(`${apiUrl}/get-client-data`, username);
                    if (!response.ok) throw new Error("Failed to fetch user job id");
                    data = await response.json();
                    if (data.job_id) {
                        localStorage.setItem("job_id", data.job_id);
                    } else {
                        setError("Unexpected error: No latest job ID returned from server.");
                    }
                }
            } catch (err) {
                setError("Unexpected error: Could not retrieve latest job ID.");
            } finally {
                setLoading(false);
            }
        };
        fetchLatestJobId();
    }, [location.pathname]);


    const handleNext = () => setStep((s) => Math.min(s + 1, steps.length - 1));
    const handleBack = () => setStep((s) => Math.max(s - 1, 0));

    if (error) {
        return (
            <Layout isLoggedIn={isLoggedIn} onLogout={logout} userName={userName}>
                <Box sx={{ width: '100%', minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'error.main' }}>
                    {error}
                </Box>
            </Layout>
        );
    }

    if (loading) {
        return (
            <Layout isLoggedIn={isLoggedIn} onLogout={logout} userName={userName}>
                <Box sx={{ width: '100%', minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    Loading...
                </Box>
            </Layout>
        );
    }

    return (
        <Layout isLoggedIn={isLoggedIn} onLogout={logout} userName={userName}>
            <Box
                sx={{
                    maxWidth: 600,
                    width: '100%',
                    margin: 'auto',
                    mt: 2,
                    p: 2,
                    border: '1px solid #ccc',
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Box sx={{ mb: 1, width: '100%', textAlign: 'center' }}>
                    <strong>Step {step + 1} of {steps.length}</strong>
                </Box>
                <Box sx={{ mb: 2, width: '100%', textAlign: 'center' }}>
                    {steps[step]()}
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button variant="outlined" onClick={handleBack} disabled={step === 0}>
                        Back
                    </Button>
                    <Button variant="contained" onClick={handleNext} disabled={step === steps.length - 1}>
                        Next
                    </Button>
                </Box>
            </Box>
        </Layout>
    );
};

export default HydroFlow;